export default "/images/PulsePoint.png?3f85bc0cb2a99b757272357adcbd6f66";